/** دسترسی به گزارش HIS: نقش admin/superadmin یا پرچم داده‌شده توسط مدیر اصلی. */

export function canAccessHisReport(): boolean {
  const r = (localStorage.getItem('admin_role') || '').trim().toLowerCase();
  if (r === 'admin' || r === 'superadmin') return true;
  return localStorage.getItem('admin_his_report_access') === '1';
}

export function setHisReportAccessFromLogin(value: boolean | undefined | null): void {
  localStorage.setItem('admin_his_report_access', value ? '1' : '0');
}

export function clearHisReportAccess(): void {
  localStorage.removeItem('admin_his_report_access');
}
